<template>
	<div class="multifactor-secret" :class="{ 'multifactor-secret__show-manual' : showSecret }">
		<p>Use an authenticator app, like <a class="no-underline" target="_blank" href="https://support.google.com/accounts/answer/1066447/get-verification-codes-with-google-authenticator-android">Google Authenticator</a> or <a class="no-underline" target="_blank" href="https://www.microsoft.com/en-us/account/authenticator">Microsoft Authenticator</a>, to {{ showSecret ? "enter or paste the code" : "scan the QR code" }}.</p>
		<div class="multifactor-secret__code my-4">
			<!-- TO DO: hasCustomTheme does not yet exist. WI 48865 -->
			<qrcode-vue
				class="multifactor-secret__qr flex flex--center"
				:value="setupUrl"
				:size="130"
				:foreground="hasCustomTheme ? 'black' : '#234652'"
				:background="hasCustomTheme ? 'white' : '#F7FAFA'"
			/>
			<c-expandable :expanded="showSecret" class="multifactor-secret__manual">
				<p class="text-primary heavy sz-2 text-center">Enter this code into your authenticator&nbsp;app</p>
				<div ref="secret" class="bg-shade-4 sz-2 p-2 text-center" :tabindex="showSecret ? '0' : '-1'" @focus="copySecret">
					{{ strippedSecret }}
				</div>
			</c-expandable>
		</div>
		<a
			class="multifactor-secret__show sz-2 underline mb-3"
			:tabindex="disabled ? '-1' : '0'"
			@keypress.enter="showSecret = !showSecret"
			@click.prevent="showSecret = !showSecret"
		>
			{{ showSecret ? "Scan the QR Code" : "Can't scan the QR code?" }}
		</a>
	</div>
</template>

<script>
	import CExpandable from '@cognitoforms/shared-components/src/components/interaction/Expandable.vue';
	import QrcodeVue from 'qrcode.vue';
	import notify from '@cognitoforms/shared-components/src/utilities/notify';

	export default {
		name: 'CMultifactorSecret',
		components: {
			CExpandable,
			QrcodeVue
		},
		props: {
			setupUrl: { type: String, default: null },
			secret: { type: String, default: null },
			disabled: { type: Boolean, default: false }
		},
		data() {
			return {
				showSecret: false
			};
		},
		computed: {
			strippedSecret() {
				// add spaces between every 4 characters for readability
				return this.secret.match(/.{1,4}/g).join(' ');
			}
		},
		methods: {
			copySecret() {
				let range;
				// Select the secret
				// if statement is for browser support
				if (document.body.createTextRange) {
					range = document.body.createTextRange();
					range.moveToElementText(this.$refs.secret);
					range.select();
				}
				else {
					const selection = window.getSelection();
					range = document.createRange();
					range.selectNodeContents(this.$refs.secret);
					selection.removeAllRanges();
					selection.addRange(range);
				}

				const copied = document.execCommand('copy');
				if (copied)
					notify('Code copied to your clipboard.', 'success');
			}
		}
	};
</script>

<style lang="scss">
.multifactor-secret {

	&__show-manual {

		.multifactor-secret__qr {
			opacity: 0;
		}

		.multifactor-secret__manual {
			opacity: 1;
		}
	}

	&__qr {
		opacity: 1;
		transition: opacity .25s;
	}

	&__code {
		position: relative;
	}

	&__manual {
		position: absolute;
		top: 50%;
		width: 100%;
		cursor: text;
		opacity: 0;
		transform: translateY(-50%);
	}

	&__show {
		display: block;
		text-align: center;
	}
}
</style>